import React from "react";
import { PageHero, PageBody, STATIC_CONTENT, renderInstituteHtml } from "./_shared";
import { usePoly } from "./PolyLayout";

export default function About() {
  const data = usePoly();
  const trust = data.trust || {};
  return (
    <div data-testid="poly-about">
      <PageHero eyebrow="Our Story" title="About the Institute" accent="amber" />
      <PageBody>
        <div className="grid md:grid-cols-2 gap-10">
          <div className="bg-white rounded-xl shadow-md p-8 border-l-4 border-[#FDC700]">
            <div className="flex items-start gap-4 mb-4">
              {trust.logo_url && (
                <img
                  src={trust.logo_url}
                  alt={trust.trust_name || "GSM"}
                  data-testid="poly-about-trust-logo"
                  className="w-20 h-20 rounded-md object-contain bg-slate-50 ring-1 ring-slate-200 p-1 shrink-0"
                  loading="lazy"
                />
              )}
              <div>
                <h2 className="font-serif text-2xl text-[#003C6C]">
                  Gramaudyogik Shikshan Mandal (GSM)
                </h2>
                {trust.registration_number && (
                  <div className="mt-1 text-[10px] tracking-[0.2em] uppercase text-[#003C6C] font-semibold">
                    Reg. No · {trust.registration_number}
                  </div>
                )}
              </div>
            </div>
            <p className="text-slate-700 leading-relaxed">{STATIC_CONTENT.about_gsm}</p>
          </div>
          <div className="bg-white rounded-xl shadow-md p-8 border-l-4 border-pink-500">
            <h2 className="font-serif text-2xl text-[#003C6C] mb-3">MIT Institute of Emerging Science and Technology</h2>
            <div className="text-slate-700 leading-relaxed prose prose-sm max-w-none" data-testid="poly-about-institute" dangerouslySetInnerHTML={{ __html: renderInstituteHtml((data.institute?.about_institute || "").trim() || STATIC_CONTENT.about_mit) }} />
          </div>
        </div>
      </PageBody>
    </div>
  );
}
